import { ReactElement } from 'react';
import { Text } from '@chakra-ui/react';

import { PropsWithChildren } from 'lib/@types';

const BadgeText = ({ children }: PropsWithChildren): ReactElement => (
  <Text
    bgColor='background.900'
    color='text.100'
    fontSize='16px'
    fontFamily='heading'
    px={4}
    py={2}
    borderRadius={32}
    mb='8'
    display='inline-block'
  >
    {children}
  </Text>
);

export default BadgeText;
